import { Bookmark as APIBookmark } from '@models/api/Bookmark'
import { Bookmark } from './Bookmark'
import { PointBookmark } from './PointBookmark'
import { ExtentBookmark } from './ExtentBookmark'
import { ISO_8601 } from '@services/DateService'
import dayjs from 'dayjs'

export type BookmarkType = PointBookmark | ExtentBookmark

export class BookmarkFactory {
  static fromAPIBookmark = (
    apiBookmark: APIBookmark
  ): BookmarkType | undefined => {
    const creationDate = dayjs.utc(apiBookmark.CREATION_TIME, ISO_8601)
    const bookmark = new Bookmark(
      apiBookmark.ID_BOOKMARK,
      apiBookmark.NAME,
      creationDate
    )

    if (apiBookmark.POSITION) {
      return PointBookmark.fromApiBookmark(bookmark, apiBookmark)
    } else if (apiBookmark.EXTENT) {
      return ExtentBookmark.fromApiBookmark(bookmark, apiBookmark)
    }
  }
}
